import React from "react";
import ValidateOnePayDonation from "./ValidateOnePayDonation";
import usePrepareValuesForSubmit from "../../../hooks/usePrepareValuesForSubmit";

const ConnectedValidateOnePayDonation = () => {
    const preparedValues = usePrepareValuesForSubmit({ isValidating: true });
    return <ValidateOnePayDonation preparedValues={preparedValues} />;
};

export default ConnectedValidateOnePayDonation;
